
import { actionTypes as actionTypesNotif } from './../../../redux/notificationAlert/index'

import { expireToken } from './../../method/expireToken/expireToken';

export const notificationAlertErrorApi = (error, dispatch) => {

    if (!error) return

    const status = error?.response?.status;
    const data = error?.response?.data?.data;

    let key = data?.message || data?.title || null;

    if (status === 400 && error.response?.data?.data?.details) {
        const detailKeys = Object.keys(error?.response?.data?.data?.details);
        const firstErrorMessage = error.response.data?.data?.details[detailKeys[0]]?.[0];

        if (firstErrorMessage) {
            dispatch({
                type: actionTypesNotif?.error,
                textAlert: firstErrorMessage
            });
            return;
        }
    }

    switch (key) {
        case 'توکن نامعتبر است.':

            dispatch(({
                type: actionTypesNotif?.error,
                textAlert: error?.response?.data?.data?.message
            }))

            expireToken()
            return

        default:

            if (error?.response?.data?.data?.message || error?.response?.data?.data?.title) {
                dispatch(({
                    type: actionTypesNotif?.error,
                    textAlert:
                        error?.response?.data?.data?.message
                            ? error?.response?.data?.data?.message
                            : error?.response?.data?.data?.title
                }))
            }
    }

}